<template>
  <div class="payment_landing">
    <PlanSetting
        :selectedTermProps="selectedTermProps"
        :selectedProductProps="selectedProductProps"
        :termProps="termProps"
        :productProps="productProps"
        :activeSyncProps="activeSyncProps"
    />
    <FeatureAndBenefits/>
    <QuestionAndAnswer/>
    <ContactUs/>
  </div>
</template>
<script>
import PlanSetting from './planSetting';
import FeatureAndBenefits from './featureAndBenefits';
import QuestionAndAnswer from './questionAndAnswer';
import ContactUs from './contactUs';

export default {
  name: 'PaymentLanding',
  props: {
    selectedTermProps: Object,
    selectedProductProps: Object,
    termProps: Array,
    productProps: Array,
    activeSyncProps: Boolean
  },
  components: {
    PlanSetting,
    FeatureAndBenefits,
    QuestionAndAnswer,
    ContactUs
  }
}
</script>
<style lang="scss">
.payment_landing {
  overflow-y: auto;
  height: calc(var(--app-height) - 93px);
  text-align: left;

  .feature_container {
    .feature_row {
      display: flex;

      .feature_item {
        display: flex;
        width: 50%;

        &:first-child {
          margin-right: 80px;
        }

        .feature_img {
          border-radius: 50px;
          width: 56px;
          height: 56px;
          background: var(--grey40);
        }

        .feature_textarea {
          margin-left: 16px;
        }
      }
    }
  }

  .contents_area {
    &.contact_container {
      height: 390px;
      border-radius: 16px;
      background: var(--blue70);
      background-image: url("/images/bg/bg-pattern01.png");
    }
  }
}
</style>